// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TOCB","col":"styles_col__3X9Pg"};